var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Banner'),_c('Fantasy'),_c('Figure'),(false)?_c('DoujinStand'):_vm._e(),_c('div',{staticClass:"footer"},[_c('Footer'),_c('Fool')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }